"use strict";
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
function equals(a, b) {
    return Math.abs(a - b) < 1e-5;
}
exports.equals = equals;
function cloneAABB(tgt, src) {
    vec3.copy(tgt.base, src.base);
    vec3.copy(tgt.max, src.max);
    vec3.copy(tgt.size, src.size);
    vec3.copy(tgt.area, src.area);
}
exports.cloneAABB = cloneAABB;
//# sourceMappingURL=utils.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/physics/lib/utils.js
 ** module id = 1178
 ** module chunks = 0
 **/